<template>
	<tr>
		<td style="border: 1px solid #333;text-align: center;">{{ index + 1 }}</td>
		<td style="border: 1px solid #333;text-align: center;">{{ item.content }}</td>
		<td style="border: 1px solid #333;text-align: center;">{{ item.dvt }}</td>
		<td style="border: 1px solid #333;text-align: center;">
			<input type="text" style="background:transparent;border:none;width:100%;text-align:center;" v-model="so_luong" v-on:keypress="numberOnly" v-money="money">
		</td>
		<td style="border: 1px solid #333;text-align: center;">
			<input type="text" style="background:transparent;border:none;width:100%;text-align:center;" v-model="don_gia" v-on:keypress="numberOnly" v-money="money">
		</td>
		<td style="border: 1px solid #333;text-align: center;">{{ item.thanh_tien | formatMoney }}</td>
	</tr>
</template>

<script>
	/* eslint-disable */ 
	import {VMoney} from 'v-money'
	export default {
		props: ["item", "index"],
		data () {
			return {
				money: {
					decimal: ',',
					thousands: '.',
					prefix: '',
					suffix: '',
					precision: 0,
					masked: false /* doesn't work with directive */
				}
			}
		},
		directives: {money: VMoney},
		computed: {
			so_luong: {
				get() {
					return this.item.sl;
				},
				set(value) {
					this.item.sl = value;
				}
			},
			don_gia: {
				get() {
					return this.item.don_gia;
				},
				set(value) {
					this.item.don_gia = value;
				}
			}
		},
		watch: {
	        item: {
	            handler(newVal) {
	            	this.item.thanh_tien = parseInt(newVal.sl.replaceAll('.', '')) * parseInt(newVal.don_gia.replaceAll('.', ''))
	            },
	            deep: true
	        }
	    },
		filters: {
			formatMoney(val) {
				if(val) {
					var formatter = new Intl.NumberFormat('vi-VN', {
				        style: 'currency',
				        currency: 'VND'
				    });
				    return formatter.format(val);
				}
			}
		},
		methods: {
		    numberOnly(evt) {
				evt = (evt) ? evt : window.event;
				var charCode = (evt.which) ? evt.which : evt.keyCode;
				if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
					evt.preventDefault();;
				} else {
					return true;
				}
		    }
		 }
	}
</script>